import { useAtomBalance } from "./useAtomBalance";
import { useBalance } from "./useBalance";
import type { CoinMode } from "./useCoinMode";
import { useCoinMode } from "./useCoinMode";

const useCoinBalance = (coinMode?: CoinMode) => {
  const globalCoinMode = useCoinMode()
  const mode = coinMode ?? globalCoinMode
  const balanceCro = useBalance()
  const balanceAtom = useAtomBalance()

  return mode === "atom" ? balanceAtom : balanceCro
}

export default useCoinBalance;